import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { userService } from '../../services'

// Async thunks
export const fetchArtistProfile = createAsyncThunk(
  'user/fetchArtistProfile',
  async (userId, { rejectWithValue }) => {
    try {
      const { data, error } = await userService.getArtistProfile(userId)
      if (error) throw new Error(error)
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const fetchArtists = createAsyncThunk(
  'user/fetchArtists',
  async (limit = null, { rejectWithValue }) => {
    try {
      const { data, error } = await userService.getArtists(limit)
      if (error) throw new Error(error)
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

export const updateArtistProfile = createAsyncThunk(
  'user/updateArtistProfile',
  async ({ user_id, updates }, { rejectWithValue }) => {
    try {
      const { data, error } = await userService.updateArtistProfile(user_id, updates)
      if (error) throw new Error(error)
      return data
    } catch (error) {
      return rejectWithValue(error.message)
    }
  }
)

const initialState = {
  artists: [],
  selected_artist: null,
  loading: false,
  error: null
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null
    },
    clear_selected_artist: (state) => {
      state.selected_artist = null
    }
  },
  extraReducers: (builder) => {
    builder
      // Fetch artist profile
      .addCase(fetchArtistProfile.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchArtistProfile.fulfilled, (state, action) => {
        state.loading = false
        state.selected_artist = action.payload
      })
      .addCase(fetchArtistProfile.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      
      // Fetch artists
      .addCase(fetchArtists.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchArtists.fulfilled, (state, action) => {
        state.loading = false
        state.artists = action.payload
      })
      .addCase(fetchArtists.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })

      // Update artist profile
      .addCase(updateArtistProfile.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateArtistProfile.fulfilled, (state, action) => {
        state.loading = false
        state.selected_artist = action.payload
      })
      .addCase(updateArtistProfile.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { clearError, clear_selected_artist } = userSlice.actions
export default userSlice.reducer